import { Heading } from "@components/typography"
import { Container, FlexBox } from "@components/wrapper"
import { Disclosure, Transition } from "@headlessui/react"
import { Faq } from "@interfaces/faq"
import FAQServices from "@services/faq.services"
import clsx from "clsx"
import { FC, useEffect, useState } from "react"
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai"

export const FAQSection: FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [faqList, setFaqList] = useState<Faq[]>([])
  const faqServices = new FAQServices()

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await faqServices.getFAQList()
        if (res.isSuccess) {
          const result = res.getValue()
          setFaqList(result)
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      } catch (e) {
        setIsLoading(false)
      }
    }

    getData()
  }, [])

  if (!faqList.length) {
    return <></>
  }

  return (
    <section className="pt-8 md:pt-15 sm-only:mb-10 relative">
      <div id="#faq" className="absolute -top-15" />
      <Container>
        <div className="mx-auto text-center sm:mb-8 mb-6">
          <Heading headingLevel="h3" className="mb-1">
            Kenali Kami
          </Heading>
          <Heading headingLevel="title" className="mb-2">
            Pertanyaan Tentang <span className="text-green">Corporate Training</span>
          </Heading>
        </div>

        <FlexBox className="sm:w-4/5 mx-auto sm:gap-5 gap-4" direction="col">
          {faqList.map((item, index) => (
            <Disclosure key={index}>
              {({ open }) => (
                <div className={clsx(!open && "border-b border-gray-a8", "sm:pb-3")}>
                  <Disclosure.Button
                    className={clsx(
                      `flex justify-between font-semibold w-full text-left sm:pb-5`,
                      "sm-only:text-xs pb-4"
                    )}
                  >
                    {item.faqQuestion}
                    {open ? (
                      <AiOutlineMinus className="text-green my-auto" />
                    ) : (
                      <AiOutlinePlus className="text-green my-auto" />
                    )}
                  </Disclosure.Button>
                  <Transition
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                  >
                    <Disclosure.Panel className="text-black-67 border-b border-gray-a8 pb-4 sm-only:text-xs sm-only:leading-[18px]">
                      {item.faqAnswer}
                    </Disclosure.Panel>
                  </Transition>
                </div>
              )}
            </Disclosure>
          ))}
        </FlexBox>
      </Container>
    </section>
  )
}
